// extracted by mini-css-extract-plugin
export var bodyRow = "_dn-d";
export var cardColumns = "_dn-e";
export var ellipsesOverflow = "_dn-2";
export var flatBottomCorners = "_dn-3";
export var flatTopCorners = "_dn-4";
export var headerActionsDropdown = "_dn-f";
export var headerBottomRow = "_dn-c";
export var headerTopRow = "_dn-b";
export var orderDetailsWrapper = "_dn-0";
export var orderInfoContainer = "_dn-1";
export var productDetails = "_dn-9";
export var productImage = "_dn-5";
export var responsiveTable = "_dn-8";
export var shipmentContainer = "_dn-a";
export var tableBottomLeft = "_dn-6";
export var tableBottomRight = "_dn-7";
export var trackingLink = "_dn-g";